import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import { useSelectListsStore } from '@/stores/selectLists.js';

// Subscribes to the Pinia selectLists store and keeps each list named in
// `selectListOptions` in sync. Components override `selectListOptions` with
// the names they care about. Fixes a Vue-3 lifecycle bug too — the original
// used `beforeDestroy` (Vue 2) which never fired in Vue 3, leaking the
// subscription.
export default {
    data() {
        return {
            selectListOptions: {}
        };
    },
    async created() {
        const selectLists = useSelectListsStore();
        this.unsubscribe = selectLists.$subscribe((_mutation, state) => {
            for (const listName in this.selectListOptions) {
                const fresh = state.lists[listName];
                if (Array.isArray(fresh) ? fresh.length : fresh) {
                    this.selectListOptions[listName] = fresh;
                }
            }
        });
        for (var listName in this.selectListOptions) {
            await this.loadList(listName);
        }
    },
    beforeUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    },
    methods: {
        async loadList(listName) {
            this.selectListOptions[listName] = await selectListOptionsDataContext.getStoreDropdownData(listName);
        }
    }
};
